import { useAccount } from '@azure/msal-react'
import { DropdownMenuLabel } from '@components/ui/dropdown-menu.tsx'

const AuthenticatedInfo = () => {
  const accountInfo = useAccount()
  if (!accountInfo) return null
  return (
    <DropdownMenuLabel className="p-0 font-normal">
      <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
        <div className="grid flex-1 text-left text-sm leading-tight">
          <span className="truncate font-medium">{accountInfo.name}</span>
          <span className="truncate text-xs text-muted-foreground">{accountInfo.username}</span>
        </div>
      </div>
    </DropdownMenuLabel>
  )
}

export default AuthenticatedInfo
